import React from "react";
import HowToPlayIMG from "../../../assets/images/tot/howtoplaytext.png";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

const HowToPlay = (props) => {
  const params = props?.paramsReducer?.gameObj?.screens?.lobby;
  const how_to_play = params.how_to_play;
  const splitText = how_to_play?.split("\n\n");
  return (
    <div className="how-to-play-wrapper">
      <div className="tot-game-title">
        <img src={HowToPlayIMG} alt="HowToPlay" />
      </div>
      <div className="d-flex flex-column justify-content-between h-100">
        <div>
          {splitText &&
            splitText.map((item) => {
              return <p>{item}</p>;
            })}
        </div>
        <div className="text-center">
          <button className="h-close-btn" onClick={props.toggle_how_to_play_modal}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  paramsReducer: state.paramsReducer,
});

export default compose(withRouter, connect(mapStateToProps, null))(HowToPlay);
